/**
 * dialog theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%403.0.0/packages/react/src/theme/recipes/dialog.ts
 */
import { defineSlotRecipe } from '@chakra-ui/react';
import { dialogAnatomy } from '@chakra-ui/react/anatomy';
export const dialog = defineSlotRecipe({
    slots: dialogAnatomy.keys(),
    base: {
        backdrop: {
            bgColor: 'secondary.persianBlue/60',
        },
        closeTrigger: {
            position: 'absolute',
            top: '16px',
            insetEnd: '20px',
        },
        content: {
            backgroundColor: '{colors.background.offWhite}',
            border: '2px solid {colors.black}',
            rounded: '8px',
        },
        footer: {
            flexDirection: 'column',
            borderTopWidth: '2px',
            borderColor: 'black',
        },
        header: {
            textAlign: 'center',
            textStyle: 'body1Bold',
            pb: '0',
        },
        title: {
            textAlign: 'center',
            textStyle: 'body1Bold',
        },
        body: {
            px: '20px',
        },
    },
    variants: {
        size: {
            md: {
                content: {
                    minH: 'min(500px, 80dvh)',
                },
                footer: {
                    py: '16px',
                },
            },
            full: {
                content: {
                    /**
                     * Fix missing modal footer on iOS.
                     * @see https://github.com/chakra-ui/chakra-ui/issues/4903
                     */
                    minH: '100dvh',
                },
            },
            xl: {
                content: {
                    minH: { base: '100dvh', desktop: 'xl' },
                    maxW: { base: '100dvw', desktop: 'xl' },
                    '--dialog-margin': {
                        base: 0,
                        desktop: 'var(--dialog-margin, var(--dialog-base-margin))',
                    },
                },
            },
        },
    },
    compoundVariants: [],
    defaultVariants: {},
});
